import React from "react";
import { Typography } from "@mui/material";
import TooltipButton from "./TooltipButton";
import InfoIconButton from "./InfoIconButtonComponent";
import MasterProjectInfoCard from "./MasterProjectInformationCard";
import { PROCORE_DOMAIN } from "../../../../utils/config/config";
import "../../static/project-dashboard-styles.css";

const ProjectInformationSummarySection = ({ projectData, budgetData, sourceProcore }) => (
	<>
		<div className="card-content-header">
		<Typography
			variant="subtitle1"
			className="card-title card-title-left-top"
		>
			Project Information Summary
		</Typography>
		<div className="project-team-icon-container">
			{/* Warning Icon with Tooltip - shown when we're past subst comp but not in Warranty or Stopped Work stage */}
			{projectData?.project_data &&
			new Date(projectData.project_data.projected_finish_date) < new Date() &&
			projectData.project_data.stage !== "Warranty" &&
			projectData.project_data.stage !== "Stopped Work" && (
				<TooltipButton
				title={`The projected finish date has passed, and the project is not in "Warranty" or "Stopped Work" stage. You can update this in your Procore admin tool.`}
				buttonText="Open Procore Admin Tool"
				onClick={() => {
					window.open(
					`https://${PROCORE_DOMAIN}/${projectData?.project_data?.procore_id}/project/admin`,
					"_blank"
					);
				}}
				iconColor="orange"
				/>
			)}

			{/* Additional case: Warranty stage and more than 1 year from projected finish date. Should be complete */}
			{projectData?.project_data &&
			projectData.project_data.stage === "Warranty" &&
			new Date() >
				new Date(
				new Date(projectData.project_data.projected_finish_date).setFullYear(
					new Date(projectData.project_data.projected_finish_date).getFullYear() + 1
				)
				) && (
				<TooltipButton
				title={`The project entered it's "Warranty" phase over a year ago. Please review and mark this project as "Inactive" in the Procore Admin Tool.`}
				buttonText="Open Procore Admin Tool"
				onClick={() => {
					window.open(
					`https://${PROCORE_DOMAIN}/${projectData?.project_data?.procore_id}/project/admin`,
					"_blank"
					);
				}}
				iconColor="orange"
				/>
			)}
			<InfoIconButton
				projectData={projectData}
				source="project-info-summary"
				sourceProcore={sourceProcore}
			/>
		</div>
		</div>
		<MasterProjectInfoCard projectData={projectData} budgetData={budgetData} />
	</>
);

export default ProjectInformationSummarySection;
